import React, { useEffect, useState } from "react";
import {
  Dialog,
  Slide,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import content from "./../assets/content.json";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  display: "flex",
  gap: "1rem",
  backgroundColor: "#081627",

  "& .MuiToggleButtonGroup-grouped": {
    borderRadius: "8px !important",
    margin: 0,
    border: "1px solid #FFC627 !important",
  },

  "& .MuiToggleButton-root": {
    color: "#FFC627",
    backgroundColor: "rgba(255, 198, 39, 0.1)",
    fontWeight: "bold",
    "&.Mui-selected": {
      backgroundColor: "#FFC627",
      color: "#081627",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#FFD84A",
      color: "#081627",
    },
    "&:hover": {
      backgroundColor: "#FFD84A",
      color: "#081627",
    },
  },
}));

export default function LanguageModal({ selectedLang, setSelectedLang, isOpen, language, languageList }) {
  const [tempLang, setTempLang] = useState(selectedLang || "");
  const currentLanguage = content[tempLang]?.content || null;
  const handleConfirm = () => {
    setSelectedLang(tempLang);
  };

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      PaperProps={{
        style: {
          borderRadius: 8,
          boxShadow: "0 0 0 5px #333",
          minHeight: "20vh",
          minWidth: "25%",
          maxWidth: "35%",
          backgroundColor: "#081627",
          color: "#FFC627",
        },
      }}
      aria-labelledby="language-dialog-title"
      aria-describedby="language-dialog-description"
    >
      <DialogTitle
        id="language-dialog-title"
        sx={{ bgcolor: "#081627", color: "#FFC627" }}
      >
        {currentLanguage?.modalTitle}
      </DialogTitle>

      <DialogContent
        id="language-dialog-description"
        sx={{ pt: 5 }}
      >
        <StyledToggleButtonGroup
          value={tempLang}
          exclusive
          aria-label={currentLanguage["lang_toggle"]}
        >
          {languageList.map((lang) => (
            <ToggleButton key={lang} value={lang} onClick={(e, lang) => setTempLang(lang)}
            >
              {lang}
            </ToggleButton>
          ))}
        </StyledToggleButtonGroup>
      </DialogContent>

      <DialogActions sx={{ bgcolor: "#081627" }}>
        <Button
          onClick={handleConfirm}
          sx={{
            color: "#081627",
            backgroundColor: "#FFC627",
            "&:hover": { backgroundColor: "#FFD84A" },
          }}
        >
          {currentLanguage?.continue}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
